export const DEFAULT_TIMESERIES = { period: 'dayRange', first: 'now()', count: -30 };

export const DEFAULT_EXCLUDELIST = 'apply';

export const DEFAULT_LANGUAGE_CODE = null;

export const DEFAULT_INCLUDE_ANONYMOUS = 'visitorId';
